<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-n3">
        {{
          inputs.language === 'en'
            ? 'Which answer best describes the purpose of recrystallizing the product?'
            : 'Quelle réponse donne la meilleure raison pour effectuer une recristallisation ?'
        }}
      </p>

      <v-radio-group
        v-model="inputs.recrystallizationPurpose"
        :disabled="!allowEditing"
        class="mb-0 pl-6"
      >
        <v-radio
          v-for="option in inputs.language === 'en' ? optionsShuffled : optionsShuffledFr"
          :key="'pt-1-' + option.value"
          class="my-1"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>

      <v-btn-toggle
        v-model="inputs.language"
        class="ml-2"
        size="small"
        dense="dense"
        rounded="rounded"
        mandatory
      >
        <v-btn :value="'en'">English</v-btn>
        <v-btn :value="'fr'">Français</v-btn>
      </v-btn-toggle>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {seededShuffle} from '@/courses/utils/seededShuffle';

export default {
  name: 'uOttawa1321Prelab2Q4',
  components: {
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    const browserLanguage = navigator.language.split('-')[0]; // Extract the language code
    return {
      inputs: {
        recrystallizationPurpose: null,
        language: browserLanguage === 'fr' ? 'fr' : 'en', // Set the initial language based on browser preference
      },
      options: [
        {text: 'It is a good way to concentrate the product', value: 'concentrateProduct'},
        {text: 'It is a good way to isolate the product', value: 'isolateProduct'},
        {text: 'It is a purification process', value: 'purifyProduct'},
        {text: 'It is an easy way to isolate and purify the product', value: 'isolateAndPurify'},
      ],
      optionsFr: [
        {
          text: 'Elle est une bonne manière de concentrer le produit',
          value: 'concentrateProductFr',
        },
        {text: 'Elle est une bonne manière d’isoler le produit', value: 'isolateProductFr'},
        {text: 'Elle est un processus de purification', value: 'purifyProductFr'},
        {
          text: 'Elle est une façon facile d’isoler et purifier le produit',
          value: 'isolateAndPurify',
        },
      ],
    };
  },
  computed: {
    seed() {
      return this.$inertia.getSeed();
    },
    optionsShuffled() {
      return seededShuffle(this.options, this.seed);
    },
    optionsShuffledFr() {
      return seededShuffle(this.optionsFr, this.seed);
    },
  },
};
</script>
